import { zfc } from "./zfc_global";
import { zfUtils } from "./zf_utils";
import { zfcfsv } from "./zfc_video";
import { zfclightbox } from "./zfc_lightbox";
import { Swiper, Navigation, Pagination, EffectCreative, A11y } from "./swiper-config";
export class zfctf {
    static buildSlider(el) {
        zfctf.sliderIndex = zfctf.sliderIndex + 1;
        el.find(".swiper-button-next").addClass('swiper-next-' + zfctf.sliderIndex);
        el.find(".swiper-button-prev").addClass('swiper-prev-' + zfctf.sliderIndex);
        const swiper = new Swiper("#" + el.attr("id"), {
            modules: [Navigation, Pagination, EffectCreative, A11y],
            effect: "creative",
            normalizeSlideIndex: true,
            preventClicksPropagation: false,
            noSwipingSelector: '.playkit-control-button',
            creativeEffect: {
                perspective: true,
                limitProgress: 2,
                prev: {
                    opacity: 0.6,
                    translate: ['-8%', 0, 0],
                    scale: 0.95,
                },
                next: {
                    opacity: 0.6,
                    translate: ['8%', 0, 0],
                    scale: 0.95,
                },
            },
            preventClicks: false,
            breakpoints: {
                720: {
                    allowTouchMove: true,
                    navigation: {
                        enabled: el.find('.zfctf-teaser').length > 1 ? true : false,
                        nextEl: '.swiper-next-' + zfctf.sliderIndex,
                        prevEl: '.swiper-prev-' + zfctf.sliderIndex
                    },
                    pagination: {
                        enabled: true,
                        el: '#' + $(el).attr('id') + '_pagination',
                        type: 'custom',
                        clickable: true,
                        dynamicBullets: false,
                        renderCustom: function (swiper, current, total) {
                            var out = '';
                            for (var i = 1; i < total + 1; i++) {
                                if (i == current) {
                                    out = out + '<button class="swiper-pagination-bullet swiper-pagination-bullet-active" role="button" aria-label="Go to slide ' + i + 1 + '"></button>';
                                }
                                else {
                                    out = out + '<button class="swiper-pagination-bullet" role="button" aria-label="Go to slide ' + i + 1 + '"></button>';
                                }
                            }
                            ;
                            return out;
                        },
                    },
                },
                0: {
                    allowTouchMove: true,
                    centeredSlides: true,
                    spaceBetween: 50,
                    loop: false,
                    loopAddBlankSlides: false,
                    slidesPerView: 'auto',
                    navigation: {
                        enabled: false,
                        nextEl: '.swiper-next-' + zfctf.sliderIndex,
                        prevEl: '.swiper-prev-' + zfctf.sliderIndex
                    },
                    pagination: {
                        enabled: true,
                        el: '#' + $(el).attr('id') + '_pagination',
                        clickable: false,
                        dynamicBullets: true,
                        dynamicMainBullets: 1
                    },
                }
            },
            a11y: {
                enabled: true,
                nextSlideMessage: "Next slide",
                prevSlideMessage: "Previous slide",
                paginationBulletMessage: "Jump to slide {{index}}",
                slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                slideRole: "group",
                itemRoleDescriptionMessage: "slide",
            },
        });
        swiper.init();
        swiper.on('transitionEnd', function () {
            const activeSlide = $("#" + el.attr("id")).find('.swiper-slide-active');
            var activeConvert = activeSlide.css('transform').split(/[,()]/);
            var activeTransform = "matrix(1, 0, 0, 1," + activeConvert[5] + ", 0)";
            activeSlide.css('transform', activeTransform);
            zfctf.pauseVideos(el);
        });
    }
    static pauseVideos(slider) {
        slider.find("video-js").each(function () {
            $(this).find("video").get(0).pause();
        });
    }
    static initSlider(teasers) {
        try {
            var that = zfctf.buildSlider(teasers);
            return true;
        }
        catch (err) {
            console.log("Initalization failed: zfctf.initSlider() " + err.message);
        }
    }
    static loadImageAndBuild(teaser) {
        teaser.find("img[data-src]").attr("src", teaser.find("img").data("src"));
        var galleryComponent = teaser.find(".zfcgac-gallery-item-wrapper");
        if (galleryComponent.length > 0) {
            var lightboxCallback = zfclightbox.create({
                elem: galleryComponent,
                slick: true,
            });
            teaser.off("click.zfctfLightbox").on("click.zfctfLightbox", lightboxCallback);
        }
        if (teaser.find(".zfctf-video-overlay").length > 0) {
            zfc.keyboardEnterToClick(teaser.find(".zfctf-video-overlay"));
            teaser
                .find(".zfctf-video-overlay")
                .off("click.zfctfVideo")
                .on("click.zfctfVideo", function () {
                var teaserWrapper = $(this).parent().parent();
                teaserWrapper.removeClass("zfctf-teaser-video-hidden");
                if (teaserWrapper
                    .find(".zfcfsv-full-size-video")
                    .hasClass("delayZFCFSVLoad")) {
                    zfcfsv.initFullSizeVideo(teaserWrapper.find(".zfcfsv-full-size-video"));
                }
                $(this).parent().css("display", "none");
                var playRetries = 0;
                var maxPlayRetries = 20;
                var tryPlay = function () {
                    var playButton = teaserWrapper.find(".playkit-pre-playback-play-button");
                    if (playButton.is(":visible")) {
                        playButton.click();
                        return;
                    }
                    playRetries++;
                    if (playRetries < maxPlayRetries) {
                        setTimeout(tryPlay, 250);
                    }
                };
                tryPlay();
            });
        }
        return true;
    }
    static init() {
        try {
            $(".zfctf-teaser").each(function (index, teaser) {
                zfUtils.loadOnScroll($(teaser), "delayZFCTFLoad", zfctf.loadImageAndBuild, 2);
            });
            $(".zfctf-teasers-slider").each(function (index, teaser) {
                zfUtils.loadOnScroll($(teaser), "delayZFCTFLoadSlider", zfctf.initSlider, 1);
            });
        }
        catch (err) {
            console.log("Initalization failed: zfctf.init() " + err.message);
        }
    }
}
zfctf.sliderIndex = 0;
try {
    zfUtils.onReady(zfctf.init);
}
catch (err) {
    console.log("Initalization failed: zfctf.init() " + err.message);
}
